import { isNumber } from 'lodash/fp';

const getStyleValue = (value) => (isNumber(value) ? `${value}px` : value);

export default getStyleValue;
